//import { Menu } from "./components";
import Menu from "./components/Menu";

function App() {
  return <div className="App">
    <section className="section-center">
        <h3>Nice Cream</h3>
        <Menu /> 
     </section>
    {/* Menu */}
  </div>;
}

export default App;
